/** 
 * @description 商品信息展示 + 数量修改
*/

import React, { useState, useEffect, useRef } from "react";
import Stepper from "@/components/Stepper";
import "./index.scss";
import { round, computeNumber } from "@/utils/publicFun";

const ShopEditBox = (props)=> {

    const {
        payDetail = {},
        maxCount,
        showPurchaseMax
    } = props
    
    const stepperRef = useRef(null)
    const stepLength = 1
    const [salePrice, setSalePrice] = useState(0)
    const [count, setCount] = useState(maxCount);

    useEffect(()=>{
        const unitPrice = payDetail.price;
        if (unitPrice === undefined || unitPrice === null || unitPrice === '') {
            return;
        }
        let purchaseMax = maxCount;
        if (!props?.noDiff && payDetail.saleBatchInfo) {
            const stock = Number(payDetail.saleBatchInfo?.stock) || 0;
            const sold = Number(payDetail.saleBatchInfo?.soldDisplay) || 0;
            const diffCount = stock - sold;
            purchaseMax = diffCount >= maxCount ? maxCount : Math.max(diffCount, 1);
        }
        setCount(purchaseMax);
        const timer = setTimeout(() => {
            const qty = stepperRef?.current?.value ?? 1;
            onCountChange(qty);
        }, 0);
        return () => clearTimeout(timer);
    },[payDetail, maxCount, props?.noDiff])

    const onCountChange = (ct)=> {
        const basePrice = Number(payDetail.price) || 0
        //价格处理
        let totalPricce = basePrice
        if(stepLength > 1) {
            totalPricce = ct > 1 ? computeNumber(ct - 1, '*', basePrice).next('*', stepLength).result: computeNumber(ct, '*', basePrice).result
        }else {
            totalPricce = computeNumber(ct, '*', basePrice).result
        }
         
        setSalePrice(totalPricce)
        props.onPriceChange && props.onPriceChange(totalPricce,ct)
    }

    return (
        <div className="shop-edit-box">
            <div className="sale_display_img">
                <img src={payDetail.imageBg} alt=""/>
            </div>
            <div className="shop_sale_content">
                {/* 藏品名称 */}
                <p>{payDetail.collectionName }</p>
                <div className="shop_sale_price">
                    <span>¥{round(payDetail.price || 0,2)}</span>
                    <div className="stepper-content">
                        {showPurchaseMax ? <span>最多可购买{count}个</span>: null}
                        <Stepper ref={stepperRef} maxValue={count} 
                            defaultValue={1} 
                            minValue={1}
                            onChange={onCountChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
} 

export default ShopEditBox;